<template>
  <v-container fluid v-bind:style="{ maxWidth: '1200px' }">
    <v-layout flex align-center>
      <v-flex xs12 sm6 md4 offset-sm3 offset-md4>
        <v-card>
          <v-card-title primary-title>
            <h1 class="headline">Oops! {{ $t('page_not_found') }}</h1>
          </v-card-title>
          <v-card-text>
            <router-link :to="{ name: 'welcome' }">{{ $t('go_home') }}</router-link>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "not-found",

  layout: "default"
}
</script>



// WEBPACK FOOTER //
// resources/js/pages/errors/404.vue